import React from "react";
import { Box, Tooltip } from "@outschool/backpack";
import LoginUserFeedback from "./LoginUserFeedback";
import { useTranslation, Trans } from "@outschool/localization";
import { magicLoginUrl } from "@outschool/routes";
import { ExternalLink } from "@outschool/ui-components-shared";

export interface TurnstileWidgetProps {
  turnstileSitekey: string | undefined;
  id: string;
  hasError: boolean;
  showMagicLoginLink?: boolean;
}

export function TurnstileWidget({
  turnstileSitekey,
  id,
  hasError,
  showMagicLoginLink = false,
}: TurnstileWidgetProps) {
  const { t } = useTranslation("ui-auth\\src\\TurnstileWidget");
  return (
    <>
      {Boolean(turnstileSitekey) && hasError && (
        <Tooltip
          title={t(
            "You may need to disable browser extensions like adblockers or parental controls for outschool.com and challenges.cloudflare.com. You can also use one of our social login options, or contact support@outschool.com if you continue to see this message.",
          )}
        >
          <Box>
            <LoginUserFeedback
              isError={true}
              userFeedbackMessage={
                showMagicLoginLink ? (
                  <Trans t={t}>
                    Your device failed an integrity check. Please refresh the
                    page to try again, or{" "}
                    <ExternalLink url={magicLoginUrl()}>
                      login a different way
                    </ExternalLink>
                  </Trans>
                ) : (
                  t(
                    "Your device failed an integrity check. Please refresh the page to try again.",
                  )
                )
              }
            />
          </Box>
        </Tooltip>
      )}
      <div style={{ display: "block", flexFlow: "row" }}>
        {Boolean(turnstileSitekey) && (
          <div className="cf-turnstile" id={id} data-size="flexible"></div>
        )}
      </div>
    </>
  );
}
